import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { fetchNewsFeed, cleanParams } from "../../lib/newsApi";
import { useNewsStore } from "../../lib/newsStore";
import { NewsFilters } from "./NewsFilters";
import { NewsCard } from "./NewsCard";

const PAGE = 30;

export const FeedView = ({ meta, filters, setFilters, onOpenStory, refreshKey }) => {
  const { searches, removeSearch } = useNewsStore();
  const [data, setData] = useState(null);
  const [offset, setOffset] = useState(0);
  const key = JSON.stringify(filters);

  useEffect(() => {
    setData(null);
    setOffset(0);
    fetchNewsFeed({ ...cleanParams(filters), dedupe: filters.dedupe, balanced: filters.balanced, limit: PAGE })
      .then(setData).catch(() => setData({ items: [], total: 0 }));
  }, [key, refreshKey]); // eslint-disable-line react-hooks/exhaustive-deps

  const more = () => {
    const next = offset + PAGE;
    fetchNewsFeed({ ...cleanParams(filters), dedupe: filters.dedupe, balanced: filters.balanced, limit: PAGE, offset: next })
      .then((r) => { setOffset(next); setData((d) => ({ ...r, items: [...d.items, ...r.items] })); });
  };

  return (
    <div data-testid="feed-view">
      <NewsFilters key={filters.q} meta={meta} filters={filters} setFilters={setFilters} />
      {searches.length > 0 && (
        <div className="mt-3 flex flex-wrap items-center gap-2" data-testid="saved-searches-row">
          <span className="text-xs text-slate-500">Saved searches:</span>
          {searches.map((s) => (
            <span key={s.id} className="inline-flex items-center gap-1 rounded-full border border-slate-200 bg-white pl-3 text-xs">
              <button onClick={() => setFilters(s.params)} className="py-1 text-sky-800" data-testid={`saved-search-apply-${s.id}`}>{s.name}</button>
              <button onClick={() => removeSearch(s.id)} className="p-1 text-slate-400 hover:text-rose-500" aria-label={`Remove ${s.name}`} data-testid={`saved-search-remove-${s.id}`}><X size={12} /></button>
            </span>
          ))}
        </div>
      )}
      <p className="mt-5 text-sm text-slate-500" data-testid="feed-result-count">
        {data ? `${data.total} stories${filters.dedupe ? ` (from ${data.matched_items} items, duplicates grouped)` : ""}` : "Loading…"}
        {filters.balanced && !filters.side && " · alternating mainstream and independent"}
      </p>
      <div className="mt-3 grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        {!data && [...Array(6)].map((_, i) => <div key={i} className="h-48 animate-pulse rounded-2xl bg-white" />)}
        {data?.items.map((i) => <NewsCard key={i.id} item={i} onOpenStory={onOpenStory} />)}
      </div>
      {data?.items.length === 0 && <p className="py-16 text-center text-slate-500" data-testid="feed-empty">No stories match these filters. Try a wider time range.</p>}
      {data?.has_more && (
        <div className="mt-8 text-center">
          <button onClick={more} className="rounded-full border border-slate-300 bg-white px-6 py-2.5 text-sm font-medium text-slate-700 hover:border-sky-400" data-testid="feed-load-more-btn">Load more</button>
        </div>
      )}
    </div>
  );
};
